import {
    SHOW_LOADING,
    BOT_LIST_SUCCESS,
    BOT_FAIL,
    CREATE_NEW_BOT,
    SET_BOT,
	ENTITY_LIST,
	CREATE_NEW_ENTITY,
	INTENT_LIST,
	SET_AGENT_ID,
	DOMAIN_LIST,
	GET_SURVEY,
	POST_SURVEY,
	UPDATE_SURVEY,
	SAVE_SURVEY,
	SET_DRAGGABLE,
	SAVE_SYSTEM_VARS,
	RESET_BOT,
	SAVE_FAQS,
	SAVE_SMALL_TALKS,
	SAVE_BOT_SETTINGS,
	SET_BOT_SETTINGS_LOADING,
	SET_BOT_SETTINGS_UPDATING
  } from '../constants/Bot';

const initState = {
  loading: false,
  message: '',
  bots:[],
  selectedBot: localStorage.getItem('bot_str_id') || '',
  entities:[],
  intents:[],
  agentId: null,
  domains: [],
  surveys: [],
  faqs:[],
  smallTalks:[],
  draggable : true,
  systemVariables:[],
  botSettings:{},
  botSettingsLoading:false,
  botSettingsUpdating:false
}

const bot = (state = initState, action) => {
	switch (action.type) {
		case BOT_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				bots: action.payload
			}
		case SET_BOT:
			return {
				...state,
				selectedBot: action.payload
			}
		case SET_DRAGGABLE:
			return {
				...state,
				draggable: action.payload
			}
		case BOT_FAIL:
			return {
				...state,
				message: action.message,
				showMessage: true,
				loading: false
			}
		case ENTITY_LIST:
			return {
				...state,		
				entities: [...action.payload],					
				loading: false
			}
		case CREATE_NEW_ENTITY:
			return {
				...state,
				entities:[...state.entities,action.payload],							
				loading: false
			}
		case INTENT_LIST:
			return {
				...state,		
				intents: action.payload,					
				loading: false
			}
		case SHOW_LOADING: {
			return {
				...state,
				loading: true
			}
		}
		case SET_AGENT_ID: {
			return {
				...state,
				agentId: action.payload
			}
		}
		case DOMAIN_LIST: {
			return {
				...state,
				domains: action.payload
			}
		}
		case SAVE_FAQS:{
			return{
				...state,
				faqs:action.payload
			}
		}
		case SAVE_SMALL_TALKS:{
			return{
				...state,
				smallTalks:action.payload.map(smallTalk=>({id:smallTalk.id,name:smallTalk.name,title:smallTalk.title}))
			}
		}
		case GET_SURVEY:{
			return {
				...state,
				loading: true
			}
		}
		case POST_SURVEY:{
			return {
				...state,
				loading: true
			}
		}
		case UPDATE_SURVEY:{
			return {
				...state,
				loading: true
			}
		}
		case SAVE_SURVEY:{
			return {
				...state,
				loading: false,
				surveys: [...action.payload]
			}
		}
		case RESET_BOT:
            return {
				loading: false,
  				message: '',
  				bots:[],
  				selectedBot: localStorage.getItem('bot_str_id') || '',
  				entities:[],
  				intents:[],
  				agentId: null,
  				domains: [],
  				surveys: [],
  				draggable : true,
  				systemVariables:[],
				botSettings:{}
            }
        
		case SAVE_SYSTEM_VARS:{
			const {schema}=action.payload
			if(schema){
				const systemVars=Object.keys(schema);
				const filteredVars=systemVars.filter(key=>( key!=="created_at" && key!=="updated_at"))
				const convertedFilteredVars=filteredVars.map(value=>({value}))
				return{
					...state,
					systemVariables:convertedFilteredVars
				}
			}
			else{
				return{
					...state
				}
			}
		}
		case SAVE_BOT_SETTINGS:{
			return{
				...state,
				botSettings:{...action.payload}
			}
		}
		case SET_BOT_SETTINGS_LOADING:{
			return{
				...state,
				botSettingsLoading:action.payload
			}
		}
		case SET_BOT_SETTINGS_UPDATING:{
			return{
				...state,
				botSettingsUpdating:action.payload
			}
		}
		default:
			return state;
	}
}

export default bot